import { fetch } from 'cross-fetch';

export const sendBeacon = url => {
  try {
    return navigator.sendBeacon(url);
  } catch (e) {
    fetch(url, {
      method: 'POST',
    });
  }
};
